import React, { FC } from 'react';
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import Grid from '@mui/material/Grid';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import Box from '@mui/material/Box';
import NumberUtils from '../../utils/numberUtils';
import Stack from '@mui/material/Stack';
import { Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { ReactComponent as PdfIcon } from '../../assets/icons/pdf-file.svg';
import { AttachmentFile } from '../../redux/api/driverFile/driverFile.model';
import './TwUploadedFileCard.scss';

interface TwUploadedFileCardProps {
  key: string;
  file: AttachmentFile;
  createdBy?: string;
  handleRemoveFile: () => void;
  handleClick: () => void;
  toUpload?: boolean;
  removableFile?: boolean;
}

const TwUploadedFileCard: FC<TwUploadedFileCardProps> = ({
  file,
  createdBy,
  handleRemoveFile,
  handleClick,
  toUpload = false,
  removableFile = true
}): JSX.Element => {
  const getImage = (): JSX.Element => {
    if (file.file_type)
      return file.file_type.match('pdf') ? <PdfIcon /> : <InsertDriveFileOutlinedIcon />;

    if (file.type) return file.type.match('pdf') ? <PdfIcon /> : <InsertDriveFileOutlinedIcon />;

    return <InsertDriveFileOutlinedIcon />;
  };

  return (
    <Grid container spacing={1} className="tw-uploaded-file-card__row">
      <Grid item xs={11}>
        <Box sx={{ cursor: toUpload ? 'auto' : 'pointer', display: 'flex' }} onClick={handleClick}>
          <Box className="tw-uploaded-file-card__image">{getImage()}</Box>
          <Stack className="tw-uploaded-file-card__document-info" flexDirection={'column'}>
            <Typography>{file.name}</Typography>
            {toUpload ? (
              <Typography component={'span'}>{NumberUtils.getFileSize(file.size)}</Typography>
            ) : (
              <Typography component={'span'}>{`${NumberUtils.getFileSize(
                file.size
              )} • Uploaded ${formatDistanceToNow(
                file.created_at ? new Date(file.created_at) : new Date()
              )} ago by ${createdBy} `}</Typography>
            )}
          </Stack>
        </Box>
      </Grid>
      {removableFile && (
        <Grid item xs={1} sx={{ paddingTop: '0px !important' }}>
          <Stack flexDirection={'row'} alignItems={'center'}>
            <CloseIcon
              sx={{ color: '#9ca3af', cursor: 'pointer' }}
              onClick={(): void => handleRemoveFile()}
            />
          </Stack>
        </Grid>
      )}
    </Grid>
  );
};

export default TwUploadedFileCard;
